import React from 'react';

const StockMovement = () => {
  return (
    <div className="stock-movement">
      <div className="page-header">
        <h2>Stok Hareketi</h2>
        <p>Stok giriş çıkış işlemlerini yönetin</p>
      </div>
      <div className="placeholder-content">
        <h3>🚧 Geliştirme Aşamasında</h3>
        <p>Bu modül yakında eklenecektir.</p>
      </div>
    </div>
  );
};

export default StockMovement; 